import React from "react";

function MatureContentPage() {
  return (
    <div className="LegalsPage">
      <div className="mature-content-guidelines">
        <h3> Mature Content Guidelines</h3>

        <p>The Contractor further represents and warrants that:</p>

        <ol>
          <li>
            The work products are developed by the contractor and the work
            products have not been copied or plagiarized, in whole or in part,
            from a third party.
          </li>
          <li>
            The work products do not violate any copyright or other intellectual
            property right of any other person or entity.
          </li>
          <li>
            The work products do not contain defamatory, inaccurate, abusive,
            obscene, profane, offensive, sexually oriented, threatening,
            harassing, racially offensive and illegal material, and does not
            advocate, promote or assist any unlawful act.
          </li>
          <li>
            All information provided to Edusity related to the contractor’s
            qualifications is accurate and complete, and Edusity has the right
            to check the authenticity of the information provided by the
            contractor.
          </li>
          <li>
            The entire right, title and interest in and to the work product is
            free and clear of any and all adverse claims and rights whatsoever,
            including, without limitation, liens, security interests, pledges
            and assignments.
          </li>
          <li>
            The definition of work product includes but is not limited to the
            verbal, oral, in writing and / or any way it is communicated to the
            students and peers.{" "}
          </li>
          <li>
            Each lesson the contractor or contractor’s personnel delivers will
            be recorded on the Edusity platform from start to finish for
            Edusity’s administration tracking, monitoring and remuneration
            purposes.
          </li>
        </ol>
      </div>
    </div>
  );
}

export default MatureContentPage;
